"use strict";

var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11;
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");
var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  LOGGER: true,
  MODE_TYPES: true,
  initializeReducerState: true,
  addOrRemoveFormEvents: true
};
exports.MODE_TYPES = exports.LOGGER = void 0;
exports.addOrRemoveFormEvents = addOrRemoveFormEvents;
exports.initializeReducerState = initializeReducerState;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/assign"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set"));
var _devLogger = require("../../dev-logger");
var _focusFirstInvalidInput = require("./focus-first-invalid-input");
_forEachInstanceProperty(_context = _Object$keys(_focusFirstInvalidInput)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _focusFirstInvalidInput[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _focusFirstInvalidInput[key];
    }
  });
});
var _getInputValues = require("./get-input-values");
_forEachInstanceProperty(_context2 = _Object$keys(_getInputValues)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getInputValues[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getInputValues[key];
    }
  });
});
var _getInputsWithNames = require("./get-inputs-with-names");
_forEachInstanceProperty(_context3 = _Object$keys(_getInputsWithNames)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getInputsWithNames[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getInputsWithNames[key];
    }
  });
});
var _getValues = require("./get-values");
_forEachInstanceProperty(_context4 = _Object$keys(_getValues)).call(_context4, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getValues[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getValues[key];
    }
  });
});
var _getValuesWithNames = require("./get-values-with-names");
_forEachInstanceProperty(_context5 = _Object$keys(_getValuesWithNames)).call(_context5, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getValuesWithNames[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getValuesWithNames[key];
    }
  });
});
var _getWatchedValues = require("./get-watched-values");
_forEachInstanceProperty(_context6 = _Object$keys(_getWatchedValues)).call(_context6, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getWatchedValues[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getWatchedValues[key];
    }
  });
});
var _isCheckable = require("./is-checkable");
_forEachInstanceProperty(_context7 = _Object$keys(_isCheckable)).call(_context7, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _isCheckable[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isCheckable[key];
    }
  });
});
var _normalizeInputValue = require("./normalize-input-value");
_forEachInstanceProperty(_context8 = _Object$keys(_normalizeInputValue)).call(_context8, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _normalizeInputValue[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _normalizeInputValue[key];
    }
  });
});
var _setNumberRegex = require("./set-number-regex");
_forEachInstanceProperty(_context9 = _Object$keys(_setNumberRegex)).call(_context9, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _setNumberRegex[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _setNumberRegex[key];
    }
  });
});
var _setValidateCallback = require("./set-validate-callback");
_forEachInstanceProperty(_context10 = _Object$keys(_setValidateCallback)).call(_context10, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _setValidateCallback[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _setValidateCallback[key];
    }
  });
});
var _shouldUpdateInputState = require("./should-update-input-state");
_forEachInstanceProperty(_context11 = _Object$keys(_shouldUpdateInputState)).call(_context11, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shouldUpdateInputState[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shouldUpdateInputState[key];
    }
  });
});
const LOGGER = (0, _devLogger.createLogger)('useValidation hook');
exports.LOGGER = LOGGER;
const MODE_TYPES = {
  change: 'onChange',
  input: 'onInput',
  focusout: 'onBlur',
  invoke: 'onInvoke'
};
exports.MODE_TYPES = MODE_TYPES;
const DEFAULT_CONFIG_OPTIONS = {
  mode: MODE_TYPES.change,
  shouldFocusInputOnValidateFail: true,
  shouldInvokeValidateCallback: true
};
function initializeReducerState(configurationOptions) {
  return {
    config: (0, _assign.default)({}, DEFAULT_CONFIG_OPTIONS, configurationOptions),
    eventHandler: null,
    formElement: null,
    inputStates: new _map.default(),
    isFormModified: false,
    watchedNames: new _set.default()
  };
}
function addOrRemoveFormEvents(formElement, addOrRemove, handlerFunction) {
  formElement[`${addOrRemove}EventListener`]('change', handlerFunction);
  formElement[`${addOrRemove}EventListener`]('input', handlerFunction);
  formElement[`${addOrRemove}EventListener`]('focusout', handlerFunction); // for blurring, because focusout bubbles up
}